import React, { createContext, useContext, useEffect, useState } from 'react';
import { createClient } from '@supabase/supabase-js';
import { getSessionUUID } from '../components/lib/AuthToken';

const SupabaseContext = createContext(null);
const AppBaseUrlContext = createContext(null);

export function SupabaseProvider({ children }) {
    const [supabase, setSupabase] = useState(null);
    const [appBaseUrl, setAppBaseUrl] = useState(null);

    useEffect(() => {
        async function init() {
            try {
                const sessionToken = await getSessionUUID();
                if (!sessionToken) return;

                const res = await fetch('/api/config', {
                    headers: { 'Authorization': `Bearer ${sessionToken}` },
                    credentials: 'include',
                });
                if (!res.ok) return;

                const { supabase_url, supabase_anon_key, app_base_url, group } = await res.json();

                if (app_base_url) setAppBaseUrl(app_base_url);

                const isCustomer = (group || '').toUpperCase() === 'CUSTOMER';

                if (supabase_url && supabase_anon_key) {
                    const client = createClient(supabase_url, supabase_anon_key, {
                        realtime: isCustomer ? false : { params: { eventsPerSecond: 10 } },
                        auth: { persistSession: true, autoRefreshToken: true },
                    });
                    setSupabase(client);
                }
            } catch (err) {
                console.error('Failed to initialise app config:', err);
            }
        }
        init();
    }, []);

    return (
        <AppBaseUrlContext.Provider value={appBaseUrl}>
            <SupabaseContext.Provider value={supabase}>
                {children}
            </SupabaseContext.Provider>
        </AppBaseUrlContext.Provider>
    );
}

export const useSupabase = () => useContext(SupabaseContext);
export const useAppBaseUrl = () => useContext(AppBaseUrlContext);
